import { render, staticRenderFns } from "./CheckBoxLabelListItem.vue?vue&type=template&id=c6bec544&scoped=true"
import script from "./CheckBoxLabelListItem.vue?vue&type=script&lang=js"
export * from "./CheckBoxLabelListItem.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxLabelListItem.vue?vue&type=style&index=0&id=c6bec544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bec544",
  null
  
)

export default component.exports